
import React, { JSX } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Login from './components/Login';
import SuperadminDashboard from './pages/SuperadminDashboard';
import ClientDashboard from './pages/ClientDashboard';
import ClientList from './components/ClientList';
import ClientForm from './components/ClientForm';
import VendorList from './components/VendorList';
import PrioritizedGames from './components/PrioritizedGames';
import Sidebar from './components/Sidebar';
import VendorOverview from './components/vendorOverview';
import UserHistory from './components/UserHistory';
import ApiLogs from './components/ApiLogs';
import ProtectedRoute from './components/ProtectedRoutes';
import Header from './components/Header';

const theme = createTheme({
  palette: {
    primary: { main: '#1976d2' },
    secondary: { main: '#dc004e' },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Header />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/superadmin"
            element={<ProtectedRoute role="superadmin" element={<SuperadminDashboard />} />}
          />
          <Route
            path="/superadmin/clients"
            element={<ProtectedRoute role="superadmin" element={<ClientList />} />}
          />
          <Route
            path="/superadmin/clients/add"
            element={<ProtectedRoute role="superadmin" element={<ClientForm />} />}
          />
          <Route
            path="/superadmin/clients/edit/:id"
            element={<ProtectedRoute role="superadmin" element={<ClientForm />} />}
          />
          <Route
            path="/superadmin/vendors"
            element={<ProtectedRoute role="superadmin" element={<VendorOverview />} />}
          />
          <Route
            path="/superadmin/vendors/:clientId"
            element={<ProtectedRoute role="superadmin" element={<VendorList />} />}
          />
          <Route
            path="/superadmin/prioritized-games"
            element={<ProtectedRoute role="superadmin" element={<PrioritizedGames />} />}
          />
          <Route
            path="/superadmin/api-logs"
            element={<ProtectedRoute role="superadmin" element={<ApiLogs />} />}
          />
          <Route
            path="/client"
            element={<ProtectedRoute role="client" element={<ClientDashboard />} />}
          />
          <Route
            path="/client/user/:userId/history"
            element={<ProtectedRoute role="client" element={<UserHistory />} />}
          />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;